import { Badge } from '@chakra-ui/react';

export function StatusPill({
  label,
  colorScheme,
  'data-testid': dataTestId,
}: {
  label: string;
  colorScheme: string;
  'data-testid'?: string;
}): React.ReactElement {
  return (
    <Badge
      fontSize="xs"
      fontWeight="bold"
      borderRadius="full"
      colorScheme={colorScheme}
      variant="outline"
      textTransform="none"
      data-testid={dataTestId}
    >
      {label}
    </Badge>
  );
}
